/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from './user';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const user = queryKey[2];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.company.company.get_company_data?pos_profile=${user}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchCompany = () => {
  const { url } = useSelector(selectAuth);
  const { data: posDetails } = useFetchPosProfileDetails();

  return useQuery(['company', url, posDetails?.name], fetcher, {
    enabled: !!posDetails,
  });
};

// https://sandbox.oyasync.app/api/method/oyasync_integrations.oyasync_integrations.api.company.company.get_company_data?pos_profile=asta
